import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isAdminUser } from "../utils/jwtRole";

/**
 * Re-evaluates admin role on navigation and auth storage updates.
 */
export function useIsAdmin() {
  const location = useLocation();
  const readAdmin = useCallback(() => isAdminUser(), []);
  const [isAdmin, setIsAdmin] = useState(readAdmin);

  useEffect(() => {
    setIsAdmin(readAdmin());
  }, [location.pathname, location.key, readAdmin]);

  useEffect(() => {
    const onAuthUpdate = () => setIsAdmin(readAdmin());
    window.addEventListener("storage", onAuthUpdate);
    window.addEventListener("sundorbon-auth-updated", onAuthUpdate);
    return () => {
      window.removeEventListener("storage", onAuthUpdate);
      window.removeEventListener("sundorbon-auth-updated", onAuthUpdate);
    };
  }, [readAdmin]);

  return isAdmin;
}

export default useIsAdmin;
